import * as React from 'react';
import { Container } from 'inversify';
import { Provider } from 'inversify-react';
import { createClient } from './MQTTClient';
import { API, createClient as createHttpClient } from './HTTP';
import { IoTBrowserClientService } from './IoTBrowserClientService';
import { mqtt5 } from 'aws-iot-device-sdk-v2';

export type MQTTClientProvider = () => Promise<mqtt5.Mqtt5Client>;

// Cross-cutting service boundaries only.
// Page-scoped services (InfluxAPI, S3BrowserAccessService) are instantiated
// directly in their respective pages.
export const DependencyInjection: React.FC<{children: any}> = (props) => {
    return (
        <Provider container={() => {
            const container = new Container();

            container.bind<API>("API").toDynamicValue(_ => createHttpClient());
            container.bind<IoTBrowserClientService>(IoTBrowserClientService).toSelf();
            container.bind<MQTTClientProvider>("MQTTClientProvider").toProvider((context) => {
                return () => createClient(context);
            });

            return container;
        }}>
            {props.children}
        </Provider>
    );
};